/* PeakView storefront loader.
   Applies PeakView edits to the compiled storefront.js at load time, then runs it.
   If storefront.js is rebuilt, any edit that no longer matches is skipped and logged as "[PeakView] patch not applied". */
const PV = (window.PV = Object.assign({"variants": {"1": 50500255252721, "2": 50500255285489, "3": 50500255318257}, "hero": "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_d141e94e-6449-4592-b64b-9ca8074dc41c.png?width=900", "manifesto": "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/peakview-hands-free.png?width=1200", "gallery": ["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_fd808ce2-b4cc-48bb-866e-2da5cf0ac0ef.png?width=1600", "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154903_fa18d5a1-54f3-4c6a-a493-4e1c633cb5d5.png?width=1600", "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_d141e94e-6449-4592-b64b-9ca8074dc41c.png?width=1600", "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154901_5b221953-535a-47f4-8c95-81676f4ddc9a.png?width=1600"], "addons": [{"id": "sd", "title": "64GB microSD card", "note": "Needed to record. Ride out of the box.", "price": 2499, "variant": 50500255416561, "image": "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_6e275cfe-19c5-49bf-bc15-6ab425600a6b.png?width=200"}, {"id": "battery", "title": "Spare battery", "note": "Double your filming time on the mountain.", "price": 2999, "variant": 50500255514865, "image": "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154901_30bcae57-1e91-4f3e-9973-2e1847fa7a7f.png?width=200"}, {"id": "case", "title": "Hard goggle case", "note": "Padded, zippered protection between runs.", "price": 2499, "variant": 50500255351025, "image": "https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_34a33b71-58fc-4598-b21d-dc5d83cb0439.png?width=200"}], "specImages": [["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_e77c980e-7b24-4fe7-9672-1c9c5d3c744d.png?width=1000", "PeakView features: 4K/30fps video, 24MP photos, 850mAh battery, anti-fog lens"], ["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154903_d2b5e67c-d2c4-42c1-9276-01bf284788dd.png?width=1000", "Adjustable camera angle: lower, middle, upper"], ["https://cdn.shopify.com/s/files/1/0803/9773/0033/files/hf_20260925_154902_d5df1afa-8a81-4011-8eeb-0f646fa7845a.png?width=1000", "Frame 7.1 in wide by 3.9 in tall; lens 8.3 in wide"]], "specs": [["Video", "4K / 30fps"], ["Photo", "24MP"], ["Battery", "850mAh"], ["Camera angle", "Up · center · down"], ["Lens", "Anti-fog, 7-step coating"], ["Frame", "Flexible TPU"], ["Transfer", "Wi-Fi to phone"], ["Storage", "microSD"]]}, window.PV || {}));
PV.addonTotal = (ids) => (ids || []).reduce((t, id) => { const a = PV.addons.find((x) => x.id === id); return t + (a ? a.price : 0); }, 0);
PV.checkout = (qty, ids) => {
  const v = PV.variants[String(qty)];
  if (!v) return;
  const items = [v + ":1"];
  (ids || []).forEach((id) => { const a = PV.addons.find((x) => x.id === id); if (a) items.push(a.variant + ":1"); });
  window.location.href = "/cart/" + items.join(",");
};
PV.subscribe = async (email) => {
  try {
    const fd = new FormData();
    fd.append("form_type", "customer");
    fd.append("utf8", "✓");
    fd.append("contact[email]", email);
    fd.append("contact[tags]", "newsletter");
    const r = await fetch("/contact", { method: "POST", body: fd });
    return r.ok && !/challenge/.test(r.url);
  } catch (e) { return false; }
};
const PATCHES = [
[
"return window.location.pathname===\"/brand\"||new URLSearchParams(window.location.search).get(\"brand\")===\"1\"?i.createElement(O1,null):i.createElement(i.Fragment,null,",
"return i.createElement(i.Fragment,null,"
],
[
"function Ad({items:b,className:D=\"\"})",
"function PVA({sel:b,set:D}){const z=(window.PV&&window.PV.addons)||[];return z.length?i.createElement(\"div\",{className:\"pv-addons\"},i.createElement(\"p\",{className:\"pv-addons-title\"},\"Complete your kit\"),z.map(d=>{const H=b.includes(d.id);return i.createElement(\"button\",{key:d.id,type:\"button\",className:`pv-addon ${H?\"on\":\"\"}`,\"aria-pressed\":H,onClick:()=>D(H?b.filter(G=>G!==d.id):[...b,d.id])},i.createElement(\"img\",{src:d.image,alt:\"\",width:\"48\",height:\"48\"}),i.createElement(\"span\",{className:\"pv-addon-text\"},i.createElement(\"strong\",null,d.title),i.createElement(\"span\",null,d.note)),i.createElement(\"span\",{className:\"pv-addon-price\"},\"+\",Ta(d.price)),i.createElement(\"span\",{className:\"pv-addon-check\"},H?\"Added\":\"Add\"))})):null}function PVS(){const P=window.PV||{};return i.createElement(\"section\",{id:\"specs\",className:\"pv-specs section-wrap\"},i.createElement(\"div\",{className:\"section-header\"},i.createElement(\"h2\",null,\"BUILT FOR\",i.createElement(\"br\",null),i.createElement(\"span\",null,\"THE MOUNTAIN.\")),i.createElement(\"p\",null,\"Everything you need to film your season, built into one pair of goggles.\")),i.createElement(\"div\",{className:\"pv-spec-grid\"},(P.specImages||[]).map(([s,a])=>i.createElement(\"figure\",{key:s},i.createElement(\"img\",{src:s,alt:a,loading:\"lazy\",width:\"1000\",height:\"1000\"})))),i.createElement(\"dl\",{className:\"pv-spec-list\"},(P.specs||[]).map(([k,v])=>i.createElement(\"div\",{key:k},i.createElement(\"dt\",null,k),i.createElement(\"dd\",null,v)))))}function Ad({items:b,className:D=\"\"})"
],
[
"const vu=Se(\"/images/alpine-campaign.webp\")",
"const vu=Se(\"/images/alpine-campaign.webp\"),PVG=(window.PV&&window.PV.gallery)||[]"
],
[
"[C,ll]=nl.useState(!1),Sl=nl.useRef(null),",
"[C,ll]=nl.useState(!1),[pvA,pvSet]=nl.useState([]),Sl=nl.useRef(null),"
],
[
"return i.createElement(\"img\",{className:`logo ${b?\"logo-light\":\"\"} ${D}`,src:Se(\"/brand/slopeframe-logo.webp\"),width:\"1800\",height:\"381\",alt:\"SLOPEFRAME\"})",
"return i.createElement(\"span\",{className:`logo pv-wordmark ${b?\"logo-light\":\"\"} ${D}`,role:\"img\",\"aria-label\":\"PeakView\"},\"PEAK\",i.createElement(\"b\",null,\"VIEW\"))"
],
[
"className:`gallery-main ${H.style}`",
"className:`gallery-main pv ${H.style}`"
],
[
"i.createElement(\"img\",{className:\"campaign-photo\",src:vu,alt:\"A skier carving fresh powder beneath dramatic alpine peaks\",",
"i.createElement(\"img\",{className:\"campaign-photo\",src:PVG[D]||vu,alt:\"PeakView 4K camera goggles on the mountain\","
],
[
"\"SLOPEFRAME / ALPINE COLLECTION\"",
"\"PEAKVIEW / 4K POV GOGGLES\""
],
[
"name:\"4K concept\"",
"name:\"4K camera\""
],
[
"\"4K camera goggles. Product photography to follow.\"",
"\"4K/30fps video and 24MP photos, built into the frame.\""
],
[
"{className:\"thumbnails\",\"aria-label\":\"Choose gallery image\"}",
"{className:\"thumbnails pv\",\"aria-label\":\"Choose gallery image\"}"
],
[
"P===4?i.createElement(\"img\",{src:Se(\"/brand/slopeframe-logo.webp\"),alt:\"\"}):i.createElement(\"img\",{src:vu,alt:\"\"})",
"i.createElement(\"img\",{src:PVG[P]||vu,alt:\"\"})"
],
[
"i.createElement(\"img\",{className:\"enlarged-photo\",src:vu,alt:\"Full alpine campaign image with a skier carving through fresh powder\"})",
"i.createElement(\"img\",{className:\"enlarged-photo\",src:(window.PV&&window.PV.hero)||vu,alt:\"PeakView 4K POV camera goggles\"})"
],
[
"\"SLOPEFRAME brand campaign. Illustrative imagery; final product photography will follow.\"",
"\"PeakView 4K POV camera goggles.\""
],
[
"i.createElement(\"img\",{src:vu,alt:\"A fresh line carved through untouched alpine snow\",loading:\"lazy\",width:\"768\",height:\"800\"})",
"i.createElement(\"img\",{className:\"pv-manifesto\",src:(window.PV&&window.PV.manifesto)||vu,alt:\"A skier carving fresh powder, hands free, wearing PeakView camera goggles\",loading:\"lazy\",width:\"768\",height:\"800\"})"
],
[
"i.createElement(p1,null)",
"i.createElement(PVS,null)"
],
[
"i.createElement(\"a\",{href:\"#reviews\"},\"Rider stories\")",
"i.createElement(\"a\",{href:\"#specs\"},\"Specs\")"
],
[
"[\"Rider stories\",\"#reviews\"]",
"[\"Specs\",\"#specs\"]"
],
[
"\"Both. SLOPEFRAME is being developed for skiers and snowboarders who want their point of view built into their goggles. Final fit and helmet compatibility will be confirmed with the selected product.\"",
"\"Both. PeakView is built for skiers and snowboarders. The adjustable strap fits over most ski and snowboard helmets, and the camera tilts up, center or down to suit your stance.\""
],
[
"\"The concept is simple: an integrated camera records your point of view. The final controls, storage requirements and phone-transfer method will be confirmed with the production model.\"",
"\"Press record once before you drop in. Video saves in 4K/30fps to a microSD card (sold separately), and you can send clips to your phone over Wi-Fi or copy them off the card on a computer. The 850mAh battery gives roughly 2 hours of recording in the cold, so carry a spare for a full day.\""
],
[
"\"Delivery estimates, shipping charges and the return policy will be published before orders open. Checkout is not active in this store preview.\"",
"\"Shipping is free on every order. Orders are processed within 3–7 business days and typically arrive 8–20 business days after they ship, with tracking. Unused items can be returned within 30 days of delivery, and damaged or defective goggles are replaced or refunded.\""
],
[
"[\"Is SLOPEFRAME available to order now?\",\"This is a storefront preview. The brand, bundles and shopping experience are ready to explore; the final product, fulfillment details and live checkout are still being prepared.\"]",
"[\"What’s in the box?\",\"PeakView 4K POV camera goggles, a USB charging cable and a quick-start guide. A microSD card isn’t included; you can add a 64GB card in your bag.\"]"
],
[
"\"Delivery, returns & the SLOPEFRAME promise\"",
"\"Free shipping · 30-day returns · real support\""
],
[
"i.createElement(\"img\",{src:Se(\"/brand/slopeframe-mark.png\"),alt:\"SLOPEFRAME\"})",
"i.createElement(\"img\",{className:\"pv-cart-img\",src:(window.PV&&window.PV.hero)||Se(\"/brand/slopeframe-mark.png\"),alt:\"PeakView camera goggles\"})"
],
[
"\"SLOPEFRAME camera goggles\"",
"\"PeakView 4K camera goggles\""
],
[
"\"Ski + snowboard collection\"",
"\"POV camera goggles · ski + snowboard\""
],
[
"i.createElement(\"button\",{className:\"remove-item\",",
"i.createElement(PVA,{sel:pvA,set:pvSet}),i.createElement(\"button\",{className:\"remove-item\","
],
[
"i.createElement(\"strong\",null,Ta(wo(z.quantity)))",
"i.createElement(\"strong\",null,Ta(wo(z.quantity)+window.PV.addonTotal(pvA)))"
],
[
"\"Shipping and taxes will be shown when checkout opens.\"",
"\"Free shipping. Taxes calculated at checkout.\""
],
[
"i.createElement(du,{onClick:()=>ll(!0)},\"Continue to checkout\")",
"i.createElement(du,{onClick:()=>{ll(!0),window.PV.checkout(z.quantity,pvA)}},\"Continue to checkout\")"
],
[
"\"You’re exploring the store preview.\"",
"\"Taking you to secure checkout…\""
],
[
"\"Live checkout opens once the final product and shipping details are ready. No payment has been taken.\"",
"\"This only takes a moment.\""
],
[
",i.createElement(\"button\",{className:\"text-link\",onClick:Cl},\"Get launch updates \",i.createElement(lt,{size:17}))",
""
],
[
"onSubmit:G=>{G.preventDefault(),z(!0)}",
"onSubmit:G=>{G.preventDefault(),z(!1),window.PV.subscribe(d).then(P=>z(P?1:2))}"
],
[
"\"Thanks for trying the preview. Email signup isn’t connected yet, so your address hasn’t been submitted.\"",
"D===2?\"Something went wrong. Please try again in a moment.\":\"You’re on the list. Welcome to the crew.\""
],
[
"i.createElement(\"a\",{href:Hy()},\"Brand guide\"),",
""
],
[
"i.createElement(\"button\",{onClick:Cl},\"Get in touch\")",
"i.createElement(\"a\",{href:\"mailto:info@flowservice.ai\"},\"Get in touch\")"
],
[
"\"Store preview · Checkout is not live. Campaign imagery is illustrative. Product details and customer reviews will be finalized before launch.\"",
"\"Questions? Email info@flowservice.ai. Free shipping on every order and 30-day returns.\""
],
[
"\"We’re finalizing our fulfillment partner. Shipping costs and delivery estimates will be published before checkout opens.\"",
"\"Shipping is free on every order. Orders are processed within 3–7 business days and typically arrive 8–20 business days after they ship. You’ll get a tracking link by email as soon as your order is on its way.\""
],
[
"\"The return window, warranty and support details are being finalized. These terms will be available before any order can be placed.\"",
"\"Return unused items in their original packaging within 30 days of delivery for a refund. If your goggles arrive damaged or stop working within 30 days, we’ll replace them or refund you in full, including shipping. Email info@flowservice.ai to start a return.\""
],
[
"i.createElement(\"h3\",null,\"Right now\")",
"i.createElement(\"h3\",null,\"Questions\")"
],
[
"\"You can explore the brand and bundle options. This preview does not accept payments or place orders.\"",
"\"Email info@flowservice.ai and we’ll reply within 1–2 business days.\""
],
[
"\"This local preview stores your selected bag in your browser. It does not send your email, track purchases or process payments.\"",
"\"We use your details to process your order, send shipping updates and, if you join our list, send PeakView emails. Payments are processed securely at checkout; we never see your full card number.\""
],
[
"i.createElement(\"p\",null,\"Email signup is a demonstration only. A full privacy policy will be provided when live services are connected.\")",
"i.createElement(\"p\",null,\"You can unsubscribe at any time. Questions about your data? Email info@flowservice.ai. \",i.createElement(\"a\",{href:\"/policies/privacy-policy\",style:{textDecoration:\"underline\"}},\"Read our full privacy policy\"),\".\")"
],
[
"\"This preview uses US dollars. Shipping destinations will be confirmed before launch.\"",
"\"Prices are shown in US dollars. Shipping is free on every order.\""
]
].concat(PV.extraPatches || []);
async function boot() {
  let s;
  try { s = await (await fetch(PV.src)).text(); }
  catch (e) { console.error("[PeakView] could not fetch storefront", e); return import(PV.src); }
  // Shopify's CDN re-minifies JS and writes non-ASCII characters as \\uXXXX / \\xXX escapes; turn them back into characters so the edits match.
  s = s.replace(/\\u([0-9a-fA-F]{4})|\\x([0-9a-fA-F]{2})/g, (m, u, x) => { const c = parseInt(u || x, 16); return c >= 0x80 && !(c >= 0xd800 && c <= 0xdfff) ? String.fromCharCode(c) : m; });
  let applied = 0;
  for (const [a, b] of PATCHES) {
    if (!s.includes(a)) { console.warn("[PeakView] patch not applied:", a.slice(0, 90)); continue; }
    s = s.split(a).join(b); applied++;
  }
  s = s.replace(/SLOPEFRAME(?!_ASSETS)/g, "PEAKVIEW").replace(/Slopeframe/g, "PeakView");
  PV.patchesApplied = applied + "/" + PATCHES.length;
  const url = URL.createObjectURL(new Blob([s], { type: "text/javascript" }));
  try { await import(url); }
  catch (e) { console.error("[PeakView] patched storefront failed; loading original", e); import(PV.src); }
}
boot();
